import React from "react"

import UserEmailAddressViewList from "./UserEmailAddressViewList"

const EmailAddressViewWidget = ({ emails, isFetching }) => (
    <div className="widget">
        <h3 className="widget-header">
            <i className="icon icon-user-email-address" />Email Addresses
        </h3>
        <div className="widget-content">
            <UserEmailAddressViewList emails={emails} isFetching={isFetching} />
        </div>
    </div>
)

export default EmailAddressViewWidget
